/**
 * SSOCallback
 *
 * Clerk redirects here after processing the SAML assertion.
 * Public password signup is off; IdP SSO may still JIT-recreate deleted users via
 * the transferable sign-up path — keep that on-app and force landing on `/landing-page`.
 */
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react'
import LoadingScreen from '../../components/Loader/Loader'

/**
 * Sign-up mode is `restricted`, so <SignUp>'s start card always renders "restricted
 * access" — the legal-consent form for a transferred sign-up only exists on its
 * `continue` route, which <SignUp> resolves from the hash on `/sign-up`.
 */
const CONTINUE_SIGN_UP_URL = '/sign-up#/continue'
const POST_AUTH_REDIRECT_URL = '/landing-page'

export default function SSOCallback() {
  return (
    <>
      <LoadingScreen message="Completing sign-in…" />
      {/* Bot protection is on for sign-ups; the transferable sign-up needs a captcha host. */}
      <div id="clerk-captcha" />
      <AuthenticateWithRedirectCallback
        signInUrl="/"
        signUpUrl="/sign-up"
        continueSignUpUrl={CONTINUE_SIGN_UP_URL}
        signInFallbackRedirectUrl={POST_AUTH_REDIRECT_URL}
        signUpFallbackRedirectUrl={POST_AUTH_REDIRECT_URL}
        signInForceRedirectUrl={POST_AUTH_REDIRECT_URL}
        signUpForceRedirectUrl={POST_AUTH_REDIRECT_URL}
        transferable={true}
      />
    </>
  )
}
